var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form-wrapper",
      attrs: { autocomplete: "off" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "form-wrapper-body m-0" }, [
        _c(
          "div",
          { staticClass: "ActivityClassSetUpChildModalBody" },
          [
            _c(
              "h3",
              { staticClass: "ActivityClassSetUpChildModalBody-title" },
              [_vm._v(_vm._s(_vm.activity.className))]
            ),
            _vm._v(" "),
            _vm.activity.status === "Full"
              ? [
                  _c(
                    "p",
                    {
                      staticClass:
                        "ActivityClassSetUpChildModalBody-description"
                    },
                    [_vm._v("Activity Full")]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            (_vm.children && _vm.children.length) ||
            (_vm.options && _vm.options.isSchool)
              ? [
                  _c(
                    "div",
                    { staticClass: "mt-3 mb-2" },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "ActivityClassSetUpChildModalBody-label"
                        },
                        [_vm._v(" Select child ")]
                      ),
                      _vm._v(" "),
                      _c("select-box", {
                        attrs: {
                          required: true,
                          "data-list": _vm.children || [],
                          disabled: _vm.options && _vm.options.isSchool,
                          "format-callback": function(child) {
                            return child.firstName + " " + child.lastName
                          }
                        },
                        on: { selected: _vm.onChildSelect }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  (_vm.activityExtras && _vm.activityExtras.length) ||
                  (_vm.options && _vm.options.isSchool)
                    ? [
                        _c(
                          "div",
                          { staticClass: "my-2" },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "ActivityClassSetUpChildModalBody-label"
                              },
                              [_vm._v(" Select activity extras ")]
                            ),
                            _vm._v(" "),
                            _c("select-box", {
                              attrs: {
                                "data-list": _vm.activityExtras || [],
                                disabled: _vm.options && _vm.options.isSchool,
                                required: false,
                                "default-value": _vm.defaultValueAddOn,
                                "multiple-select": true,
                                "format-callback": function(addOn) {
                                  return addOn.name
                                }
                              },
                              on: { selected: _vm.onActivityExtrasSelect }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.teachers &&
                    _vm.teachers.length &&
                    _vm.activitiesClassRequired &&
                    _vm.activitiesClassRequired.teacher) ||
                  (_vm.options &&
                    _vm.options.isSchool &&
                    _vm.activitiesClassRequired &&
                    _vm.activitiesClassRequired.teacher)
                    ? [
                        _c(
                          "div",
                          { staticClass: "my-2" },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "ActivityClassSetUpChildModalBody-label"
                              },
                              [_vm._v(" Who is your teacher")]
                            ),
                            _vm._v(" "),
                            _c("select-box", {
                              attrs: {
                                "data-list": _vm.teachers || [],
                                disabled: _vm.options && _vm.options.isSchool,
                                required:
                                  _vm.activitiesClassRequired &&
                                  _vm.activitiesClassRequired.teacherRequired,
                                "format-callback": function(teacher) {
                                  return teacher.name
                                }
                              },
                              on: { selected: _vm.onTeacherSelect }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.pickUps &&
                    _vm.pickUps.length &&
                    _vm.activitiesClassRequired &&
                    _vm.activitiesClassRequired.pickUpOptions) ||
                  (_vm.options &&
                    _vm.options.isSchool &&
                    _vm.activitiesClassRequired &&
                    _vm.activitiesClassRequired.pickUpOptions)
                    ? [
                        _c(
                          "div",
                          { staticClass: "my-2" },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "ActivityClassSetUpChildModalBody-label"
                              },
                              [_vm._v("Pickup Options")]
                            ),
                            _vm._v(" "),
                            _c("select-box", {
                              attrs: {
                                "data-list": _vm.pickUps || [],
                                disabled: _vm.options && _vm.options.isSchool,
                                required:
                                  _vm.activitiesClassRequired &&
                                  _vm.activitiesClassRequired
                                    .pickUpOptionsRequired,
                                "format-callback": function(pickUp) {
                                  return pickUp.name
                                }
                              },
                              on: { selected: _vm.onPickUpSelect }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tShirtSizes &&
                  _vm.tShirtSizes.length &&
                  _vm.activitiesClassRequired &&
                  _vm.activitiesClassRequired.tshirt
                    ? [
                        _c("div", { staticClass: "mb-5" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "ActivityClassSetUpChildModalBody-label"
                            },
                            [_vm._v(" T-Shirt size ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center w-100 mb-4"
                            },
                            [
                              _c("p", { staticClass: "w-25 text-gray mb-0" }, [
                                _vm._v("Young")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ActivityClassSetUpChildModalBody-sizes w-75"
                                },
                                _vm._l(_vm.sizesYoung, function(sizeYoung) {
                                  return _c("div", { key: sizeYoung.id }, [
                                    _c(
                                      "label",
                                      {
                                        class: [
                                          "ActivityClassSetUpChildModalBody-sizes-size",
                                          { disabled: !sizeYoung.status }
                                        ]
                                      },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            name: "tShirt",
                                            id: sizeYoung.id,
                                            disabled: !sizeYoung.status
                                          },
                                          domProps: {
                                            value: sizeYoung.id,
                                            checked:
                                              sizeYoung.id ==
                                              _vm.form.tshirtSizeId
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.form.tshirtSizeId =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(sizeYoung.size.substring(1))
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center w-100" },
                            [
                              _c("p", { staticClass: "w-25 text-gray mb-0" }, [
                                _vm._v("Adult")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ActivityClassSetUpChildModalBody-sizes w-75"
                                },
                                _vm._l(_vm.sizesAdult, function(sizeAdult) {
                                  return _c("div", { key: sizeAdult.id }, [
                                    _c(
                                      "label",
                                      {
                                        class: [
                                          "ActivityClassSetUpChildModalBody-sizes-size",
                                          { disabled: !sizeAdult.status }
                                        ]
                                      },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            name: "tShirt",
                                            id: sizeAdult.id,
                                            disabled: !sizeAdult.status
                                          },
                                          domProps: {
                                            value: sizeAdult.id,
                                            checked:
                                              sizeAdult.id ==
                                              _vm.form.tshirtSizeId
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.form.tshirtSizeId =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(" " + _vm._s(sizeAdult.size))
                                        ])
                                      ]
                                    )
                                  ])
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "error mt-3" }, [
                            _vm._v(_vm._s(_vm.errors.first("tShirt")))
                          ])
                        ])
                      ]
                    : _vm._e()
                ]
              : [
                  _c(
                    "div",
                    {
                      staticClass: "not-found m-0 text-center",
                      style: { height: "85%" }
                    },
                    [
                      _c("img", {
                        style: {
                          width: "280px",
                          height: "200px",
                          "margin-bottom": "25px"
                        },
                        attrs: {
                          src: require("../../assets/img/background.png")
                        }
                      }),
                      _vm._v(
                        "\n                    Oh no! First add child, please.\n                "
                      )
                    ]
                  )
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          key: _vm.formsButtonUpdate,
          staticClass: "form-wrapper-footer d-flex justify-content-between"
        },
        [
          _vm.activity.price === 0
            ? _c(
                "div",
                {
                  staticClass: "ActivityClassSetUpChildModalBottom text-green"
                },
                [_vm._v("\n            FREE\n        ")]
              )
            : _c("div", { staticClass: "d-flex flex-column" }, [
                _vm.options && _vm.options.isSchool
                  ? _c(
                      "span",
                      { staticClass: "ActivityClassSetUpChildModalBottom" },
                      [_vm._v(_vm._s(_vm.activity.price.toFixed(2)))]
                    )
                  : _c(
                      "span",
                      { staticClass: "ActivityClassSetUpChildModalBottom" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("currencySign")(_vm.schoolInfo.currency)
                          ) +
                            " " +
                            _vm._s(_vm.activity.price.toFixed(2))
                        )
                      ]
                    ),
                _vm._v(" "),
                _c("span", { style: { color: "#0d0d25" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("toCapitalize")(_vm.activity.billingType)) +
                      " "
                  )
                ])
              ]),
          _vm._v(" "),
          _vm.activityForms.length === 0
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "spinner",
                      rawName: "v-spinner",
                      value: _vm.isLoading,
                      expression: "isLoading"
                    }
                  ],
                  class: [
                    "form-wrapper-footer-button",
                    "primary-btn",
                    _vm.activity.status === "Full" &&
                      "form-wrapper-footer-button-waitlist",
                    _vm.isLoading && "ie-spinner"
                  ],
                  style: { width: "150px" },
                  attrs: { disabled: _vm.disabledButton, type: "submit" }
                },
                [
                  _vm.activity.status === "Online"
                    ? [
                        _vm._v(
                          _vm._s(
                            _vm.isNewPaymentFlow ? "Pay Now" : "Add to Cart"
                          )
                        )
                      ]
                    : _vm.activity.status === "Full"
                    ? [_vm._v(" Add to Waitlist ")]
                    : _vm._e()
                ],
                2
              )
            : _c(
                "button",
                {
                  directives: [
                    {
                      name: "spinner",
                      rawName: "v-spinner",
                      value: _vm.isLoading,
                      expression: "isLoading"
                    }
                  ],
                  class: ["primary-btn"],
                  style: { width: "150px" },
                  attrs: { disabled: _vm.disabledButton },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.goToCustomForms($event)
                    }
                  }
                },
                [_vm._v("\n            Continue\n        ")]
              )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc853064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc853064","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ActivityClassSetUpChildModal.vue
// module id = null
// module chunks = 